export const PARCEL_CULTURE_CHANGE = "PARCEL_CULTURE_CHANGE";
export const PARCEL_GROUP_CHANGE = "PARCEL_GROUP_CHANGE";
export const PARCEL_COPY = "PARCEL_COPY";